/* eslint-disable max-len */
import React, { Fragment } from 'react'
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector ,useDispatch} from 'react-redux';
import SearchEmptyScreen from '../../../../../../components/SearchEmptyScreen';
import ExportTablebody from './TableBody';
const PatientExportTable=({pageNumber,List,setConfirmationState,setTextAreaMsg})=>{
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const selectedRows=useSelector((state)=>state?.MultiSelectSlice?.selectedRows)
    const urlParams = new URLSearchParams(window.location.search);
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    return(
        <div>
            <div className='h-[calc(100vh-267px)] 2xl:h-[calc(100vh-266px)] overflow-auto scrollbar_purple pb-2.5' onScroll={()=>setSelectedIndex('')}>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username
                                </span>
                            </th>
                            <th className="pl-[60px] py-2 min-w-[230px]"  >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Timestamp
                                </span>
                            </th>
                            <th className="pl-[60px] py-2 min-w-[190px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Filter Name
                                </span>
                            </th>
                            <th className="pl-[60px] py-2 min-w-[187px]" >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Table Name
                                </span>
                            </th>
                            <th className="pl-[60px] pr-[18px] py-2 min-w-[400px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Exported Column Name
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <ExportTablebody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default PatientExportTable